import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik, useFormikContext } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import { pincodeListAction } from "../../redux/actions/general-action";
import { useNavigate } from "react-router-dom";
import { handelEnabled } from "./handel-enabled";
import { handelLabel } from "./handel-label";
import * as Yup from "yup";
import Contacts2Icon from "../../assets/icons/admin-customer-icons/contacts2-icon";
import { shouldBeDisplay } from "./shouldBeDisplayed";

function Contacts({
  customerId,
  contacts,
  page,
  disabled,
  setCurrentTab,
  contactId,
  customization,
  // loading,
  // setLoading,
}) {
  const [loading, setLoading] = useState(false);
  const [customData, setcustomData] = useState([]);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();

  const dispatch = useDispatch();

  let initialValues = {
    contacts: localStorageData?.contacts ?? contacts,
  };

  const addContact = {
    cmr_id: customerId,
    // cmr_contact_person_id:
    //   contactId ?? initialValues.contacts[0].cmr_contact_person_id,
    contact_person_name: "",
    contact_person_phone: null,
    contact_person_email: null,
    contact_person_country: null,
    contact_person_state: null,
    contact_person_district: null,
    contact_person_city: null,
    contact_person_pincode: null,
    contact_address: null,
    cmr_default_contact_persons: false,
  };

  // useEffect(() => {
  //   if (!Object.hasOwn(initialValues.contacts, "cmr_id")) {
  //     initialValues = {
  //       contacts: {
  //         ...initialValues?.contacts,
  //         cmr_id: customerId,
  //       },
  //     };
  //   }
  // }, [customerId]);

  // useEffect(() => {
  //   if (!Object.hasOwn(initialValues.contacts, "cmr_contact_person_id")) {
  //     initialValues = {
  //       contacts: {
  //         ...initialValues?.contacts,
  //         cmr_contact_person_id: contactId,
  //       },
  //     };
  //   }
  // }, [contactId]);

  // const UpdateLocalStorage = ({ values }) => {
  //   useEffect(() => {
  //     console.log("initialValues", initialValues);
  //     localStorage.setItem("customerAdmin", JSON.stringify(values));
  //   }, [values]);
  //   return null;
  // };
  //   useEffect(() => {}, []);
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const handleDefaultContact = (values, setFieldValue, selectedIndex) => {
    const updatedContact = values.contacts.map((item, index) => ({
      ...item,
      cmr_default_contact_persons: index === selectedIndex,
    }));

    setFieldValue("contacts", updatedContact);
  };

  const handleAddContact = (values, setFieldValue) => {
    const updatedContact = [...values.contacts, { ...addContact }];
    setFieldValue("contacts", updatedContact);
  };

  const handleDeleteContact = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one contact");
    else if (values.contacts[index].cmr_default_contact_persons === true) {
      return errorToast("Cannot delete the default contact");
    } else {
      const updatedContact = values.contacts.filter((_, i) => i !== index);
      setFieldValue("contacts", updatedContact);
    }
  };

  const onSuccess = () => {
    setLoading(false);
    successToast("Saved successfully");
    setCurrentTab("Banking");
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data.message);
  };

  const onSave = (values, { validateForm, errors }) => {
    if (loading) return;
    setLoading(true);
    let sendData = [...values.contacts];
    if (page !== "edit") {
      let firstItem = values.contacts[0];
      let updatedFirstItem = {
        ...firstItem,
        cmr_id: customerId,
        cmr_contact_person_id: contactId,
      };
      sendData[0] = updatedFirstItem;
    }

    dispatch(
      adminCustomerUpdateContactPersonAction(
        { contactPersonsData: values.contacts },
        onSuccess,
        onError
      )
    );
  };

  function fetchAddressFn(inputValue, setFieldValue, index) {
    if (inputValue?.length === 6) {
      dispatch(
        pincodeListAction(
          inputValue,
          (response) => {
            if (response?.[0]?.Status === "Error") {
            } else {
              const firstPostOffice = response?.[0]?.PostOffice?.[0];
              setFieldValue(
                `contacts[${index}].contact_person_state`,
                firstPostOffice?.State
              );
              setFieldValue(
                `contacts[${index}].contact_person_city`,
                firstPostOffice?.Division
              );
              setFieldValue(
                `contacts[${index}].contact_person_district`,
                firstPostOffice?.District
              );
              // setFieldValue(
              //   `contacts[${index}].cmr_village`,
              //   firstPostOffice?.Name
              // );
              setFieldValue(
                `contacts[${index}].contact_person_country`,
                firstPostOffice?.Country
              );
            }
          },
          (data) => {
            setFieldValue(`contacts[${index}].contact_person_state`, "");
            setFieldValue(`contacts[${index}].contact_person_city`, "");
            setFieldValue(`contacts[${index}].contact_person_district`, "");
            setFieldValue(`contacts[${index}].contact_person_country`, "");
          }
        )
      );
    } else {
      setFieldValue(`contacts[${index}].contact_person_state`, "");
      setFieldValue(`contacts[${index}].contact_person_city`, "");
      setFieldValue(`contacts[${index}].contact_person_district`, "");
      setFieldValue(`contacts[${index}].contact_person_country`, "");
    }
  }

  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "contacts");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);


  const phoneRegex = /^[0-9]\d{9}$/;
  const pincodeRegex = /^[1-9][0-9]{5}$/;

  const validationSchema = Yup.object().shape({
    contacts: Yup.array().of(
      Yup.object().shape({
        // contact_person_name: Yup.string()
        //   .min(2, "Full Name must be at least 2 characters")
        //   .max(100, "Full Name must not exceed 100 characters"),

        contact_person_phone: Yup.string()
          .nullable()

          // .required("Phone is required")
          .matches(
            phoneRegex,
            "Please enter a valid 10-digit phone number starting with 6-9"
          ),
        contact_person_pincode: Yup.string().matches(
          pincodeRegex,
          "Please enter a valid 6-digit pincode"
        ),

        contact_person_email: Yup.string()
          .nullable(),
      })
    ),
  });
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(values)}
          {console.log("**", customerId)}
          <UpdateLocalStorage values={values} />
          {/* <UpdateCmrId customerId={customerId} /> */}
          {/* <UpdateContactId contactId={contactId} /> */}
          <LoadingOverlay isLoading={loading} />
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Contacts2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Contact Person
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Add people who can be contacted for this party
                  </label>
                </div>
              </div>
              <div className="flex gap-[6px]">
                <AddButton
                  prefixIcon={true}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  onclkFn={() => handleAddContact(values, setFieldValue)}
                  text={<span>Add Contact Person</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            </div>
            {values?.contacts?.map((item, index) => (
              <div
                // key={index}
                className="px-[34px] pt-[34px] pb-[10px] flex-col rounded-2xl bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
              >
                <div className="flex mb-6 justify-between">
                  <div className="flex flex-row gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                      <label className="text-[var(--customer-contact-icon-fg)] text-[length:var(--customer-contact-icon-fs)] font-[var(--customer-contact-icon-fw)]">
                        {index + 1}
                      </label>
                    </div>
                    <div className="flex flex-col self-center">
                      <label className="h-full text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                        Contact Person
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-4 items-center">
                    {item.cmr_default_contact_persons ? (
                      <div className="px-5 py-[5px] rounded-full bg-[var(--customer-default-bg)] flex items-center">
                        <label className="text-[var(--customer-default-fg)] font-[var(--customer-default-fw)]">
                          Default
                        </label>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          if (page !== "view")
                            handleDefaultContact(values, setFieldValue, index);
                        }}
                        className="px-5 py-[5px] rounded-full bg-[var(--customer-set-default-bg)] flex items-center cursor-pointer"
                      >
                        <label className="text-[var(--customer-set-default-fg)] font-[var(--customer-default-fw)]">
                          Set as Default
                        </label>
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        if (page !== "view")
                          handleDeleteContact(
                            index,
                            values,
                            setFieldValue,
                            values.contacts.length
                          );
                      }}
                      className={`${
                        values.contacts.length <= 1
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>

                {/* Grid Layout for Form Fields */}
                <div
                  className="grid gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay("contact_person_name", page, customData) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_name`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_name",
                          customData
                        )}`}
                        allowSpecial={true}
                        label={handelLabel("contact_person_name", customData)}
                        isDisabled={handelEnabled(
                          "contact_person_name",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "contact_person_phone",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        type="number"
                        maxLength={10}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_phone`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_phone",
                          customData
                        )}`}
                        label={handelLabel("contact_person_phone", customData)}
                        isDisabled={handelEnabled(
                          "contact_person_phone",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "contact_person_district",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_district`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_district",
                          customData
                        )}`}
                        label={handelLabel(
                          "contact_person_district",
                          customData
                        )}
                        // isDisabled={handelEnabled(
                        //   "contact_person_district",
                        //   page,
                        //   customData
                        // )}

                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay("contact_person_city", page, customData) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_city`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_city",
                          customData
                        )}`}
                        label={handelLabel("contact_person_city", customData)}
                        // isDisabled={handelEnabled(
                        //   "contact_person_city",
                        //   page,
                        //   customData
                        // )}
                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "contact_person_state",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_state`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_state",
                          customData
                        )}`}
                        label={handelLabel("contact_person_state", customData)}
                        // isDisabled={handelEnabled(
                        //   "contact_person_state",
                        //   page,
                        //   customData
                        // )}
                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "contact_person_pincode",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        type="number"
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_pincode`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_pincode",
                          customData
                        )}`}
                        label={handelLabel(
                          "contact_person_pincode",
                          customData
                        )}
                        isDisabled={handelEnabled(
                          "contact_person_pincode",
                          page,
                          customData
                        )}
                        handleChange={(e) => {
                          fetchAddressFn(
                            e?.target?.value,
                            setFieldValue,
                            index
                          );
                        }}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "contact_person_country",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_country`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_country",
                          customData
                        )}`}
                        label={handelLabel(
                          "contact_person_country",
                          customData
                        )}
                        // isDisabled={handelEnabled(
                        //   "contact_person_country",
                        //   page,
                        //   customData
                        // )}
                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "contact_person_email",
                    page,
                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        onKeyDown={() => {}}
                        allowSpecial={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex flex-col gap-2 w-full align-end"
                        name={`contacts[${index}].contact_person_email`}
                        placeholder={`Enter ${handelLabel(
                          "contact_person_email",
                          customData
                        )}`}
                        label={handelLabel("contact_person_email", customData)}
                        type="text"
                        isDisabled={handelEnabled(
                          "contact_person_email",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                </div>

                {/* Address Field - Full Width */}
                {shouldBeDisplay("contact_address", page, customData) && (
                  <div className="flex flex-col gap-2 mt-3">
                    <label className="text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                      {handelLabel("contact_address", customData)}
                    </label>
                    <TextAreaField
                      name={`contacts[${index}].contact_address`}
                      placeholder={`Enter ${handelLabel(
                        "contact_address",
                        customData
                      )}`}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex flex-col gap-2 w-full align-end"
                      label=""
                      isDisabled={handelEnabled(
                        "contact_address",
                        page,
                        customData
                      )}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]`}
                      containerClass="flex flex-col gap-2 w-full"
                    />
                  </div>
                )}
              </div>
            ))}

            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(`/edit-customer-admin/${customerId}`, {
                      state: { tab: "Contacts" },
                    })
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Contacts;
function UpdateLocalStorage({ values }) {
  const [isInitialRender, setIsInitialRender] = useState(true);

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return; // Skip the first render
    }

    console.log("Updating localStorage with values:", values);
    try {
      const existingData =
        JSON.parse(localStorage.getItem("customerAdmin")) || {};
      const updatedData = {
        ...existingData,
        contacts: values.contacts,
      };
      localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
    } catch (error) {
      console.error("Error updating localStorage:", error);
    }
  }, [values, isInitialRender]);

  return null;
}

function UpdateCmrId({ customerId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.contacts?.[0] && !Object.hasOwn(values.contacts[0], "cmr_id")) {
      setFieldValue("contacts[0].cmr_id", customerId);
    }
  }, [customerId, setFieldValue]);

  return null;
}

function UpdateContactId({ contactId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.contacts?.[0] &&
      !Object.hasOwn(values.contacts[0], "cmr_contact_person_id")
    ) {
      setFieldValue("contacts[0].cmr_contact_person_id", contactId);
    }
  }, [contactId, setFieldValue]);

  return null;
}
